var r=function(r,n){for(var t=-1,e=null==r?0:r.length;++t<e;)if(n(r[t],t,r))return!0;return!1};export{r as default};
//# sourceMappingURL=_arraySome.js.map
